import { render, staticRenderFns } from "./ProjectionForm.vue?vue&type=template&id=3dddfe66&"
import script from "./ProjectionForm.vue?vue&type=script&lang=js&"
export * from "./ProjectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports